 function validate (value) { 

    var dia = parseInt(value.substring(0, 2));
    var mes = parseInt(value.substring(3, 5))-1;  
    var ano = parseInt(value.substring(6, 10));
    var data =  new Date(ano, mes, dia) 
    
    const dataAtual= new Date();
    
    if (data.getTime() < dataAtual.getTime()){
        return true;
    } else {
        return false;
    } 
 
  }
  export default validate